module.exports = __webpack_public_path__ + "img/manchester-city-logo-icon.f2dc4229.png";